export default {
  props: {
    /**
     * Valor para o input
     */
    value: {
      required: false,
      type: [Number, String, Object, Array],
    },
    /**
     * Label
     */
    label: {
      required: false,
      type: [Number, String],
    },
    /**
     * Placeholder
     */
    placeholder: {
      required: false,
      type: String,
    },
    /**
     * Regras de validação para o valor do input
     */
    rules: {
      required: false,
      type: Array,
      default: () => [],
    },
    /**
     * Mensagens de erro para serem exibidas
     */
    errorMessages: {
      required: false,
      type: Array,
      default: () => [],
    },
    /**
     * Flag para indicar que é um campo requerido
     */
    required: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para desabilitar o campo
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Dica para ser colocada em baixo do input.
     */
    hint: {
      type: String,
      required: false,
    },
    /**
     * Flag para indicar que o campo está carregando
     */
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para esconder os os detalhes (div de mensagens de validação/hint)
     */
    hideDetails: {
      type: [Boolean, String],
      required: false,
      default: false,
    },
    /**
     * Flag para indicar que o input deve ser pequeno (defaults: {mobile: false, desktop: false})
     */
    small: {
      type: Boolean,
      required: false,
    },
    /**
     * Flag para indicar que o input deve ser grande (defaults: {mobile: true, desktop: false})
     */
    large: {
      type: Boolean,
      required: false,
    },
    /**
     * Flag para indicar que o input deve ser médio (defaults: {mobile: false, desktop: true})
     */
    medium: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    isDense() {
      const isMobile = this.$vuetify.breakpoint.xs

      if (!this.small && !this.medium && !this.large) {
        return isMobile ? false : true
      }

      if (this.large) {
        return false
      }

      return this.small || this.medium
    },
    currentLabel() {
      if (this.required && !this.label) return ''
      return this.required ? `${this.label} *` : this.label
    },
  },
}
